'use client';

import { useEffect, useState } from 'react';
import {
  AE_PRICING_LINK_ABSOLUTE,
  BlurredButtonLink,
  useAutoPlayVideoRef,
} from '../shared';
import { useForwardSearchParams } from '../../utils/useForwardSearchParams';
import styles from './TopVideoSection.module.css';

const mobileVideoPath =
  'https://public-web-assets-cfront.ultrahuman.com/bumper_metabolic_mobile.mp4';
const desktopVideoPath =
  'https://public-web-assets-cfront.ultrahuman.com/bumper_metabolic.mp4';

export const TopVideoSection = () => {
  const [appeared, setAppeared] = useState(false);
  const videoRef = useAutoPlayVideoRef();
  const forwardSearchParams = useForwardSearchParams();

  useEffect(() => {
    setAppeared(true);

    const setDesktopVideoIfLargeScreen = () => {
      if (!videoRef.current) {
        return;
      }
      if (
        window.innerWidth > window.innerHeight &&
        (!videoRef.current.src ||
          !videoRef.current.src.endsWith(desktopVideoPath))
      ) {
        videoRef.current.src = desktopVideoPath;
        return;
      }
      if (
        window.innerWidth < window.innerHeight &&
        (!videoRef.current.src ||
          !videoRef.current.src.endsWith(mobileVideoPath))
      ) {
        videoRef.current.src = mobileVideoPath;
        return;
      }
    };

    window.addEventListener('resize', setDesktopVideoIfLargeScreen);
    setDesktopVideoIfLargeScreen();

    return () => {
      window.removeEventListener('resize', setDesktopVideoIfLargeScreen);
    };
  }, []);

  return (
    <div className={styles.container}>
      {}
      <video preload="none" loop autoPlay muted playsInline ref={videoRef}>
        <source src={mobileVideoPath} type="video/mp4" />
      </video>
      <div className={`${styles.content} u-grid`} data-appeared={appeared}>
        <div>
          <h1 className={styles.title}>Discover Metabolic Fitness</h1>
          <h2 className={styles.subTitle}>
            Improve your diet and exercise based on glucose biomarkers.
          </h2>

          <div className={styles.buttonContainer}>
            <BlurredButtonLink
              className={styles.blurredBtn}
              href={forwardSearchParams(AE_PRICING_LINK_ABSOLUTE)}
              rel="noopener noreferrer"
            >
              Buy now
            </BlurredButtonLink>
          </div>
        </div>
      </div>
    </div>
  );
};

